import {
  PrimaryNavIdentifier,
  TertiaryNavIdentifier,
  SecondaryNavItem,
} from '@zola-helpers/client/dist/es/constants/navConstants';

export const getInvitesTertiaryItems = (hideTertiaryNav?: boolean): SecondaryNavItem[] => {
  if (hideTertiaryNav) {
    return [];
  }
  const saveTheDate = {
    path: '/wedding-planning/save-the-date/shop',
    title: 'Save the dates',
    id: TertiaryNavIdentifier.SAVE_THE_DATE,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const matchingSuites = {
    path: '/wedding-planning/suites/shop',
    title: 'Matching suites',
    id: TertiaryNavIdentifier.COLLECTIONS_PAPER,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const digitalSaveTheDate = {
    path: '/wedding-planning/digital/save-the-date/shop',
    title: 'Digital save the dates',
    id: TertiaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const invitations = {
    path: '/wedding-planning/invitations/shop',
    title: 'Invites',
    id: TertiaryNavIdentifier.INVITATIONS,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const weddingShower = {
    path: '/wedding-planning/bridal-shower/shop',
    title: 'Shower invitations',
    id: TertiaryNavIdentifier.INVITATIONS,
    parent: PrimaryNavIdentifier.PAPER,
    newTag: true,
  };
  const enclosureCards = {
    path: '/wedding-planning/enclosures/shop',
    title: 'Enclosures',
    id: TertiaryNavIdentifier.INVITATIONS,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const menus = {
    path: '/wedding-planning/menus/shop',
    title: 'Menus',
    id: TertiaryNavIdentifier.DAY_OF,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const programs = {
    path: '/wedding-planning/programs/shop',
    title: 'Programs',
    id: TertiaryNavIdentifier.DAY_OF,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const placeCards = {
    path: '/wedding-planning/place-cards/shop',
    title: 'Place cards',
    id: TertiaryNavIdentifier.DAY_OF,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const thankYouCards = {
    path: '/wedding-planning/thank-you-cards/shop',
    title: 'Thank yous',
    id: TertiaryNavIdentifier.THANK_YOUS,
    parent: PrimaryNavIdentifier.PAPER,
  };

  const changeTheDate = {
    path: '/wedding-planning/change-the-date/shop',
    title: 'Change the dates',
    id: TertiaryNavIdentifier.SAVE_THE_DATE,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const disney = {
    path: '/wedding-planning/disney',
    title: 'Disney',
    id: TertiaryNavIdentifier.COLLECTIONS_PAPER,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const albums = {
    title: 'Albums',
    path: '/wedding-albums/shop',
    id: TertiaryNavIdentifier.ALBUMS,
    parent: PrimaryNavIdentifier.PAPER,
  };
  const matchingSuitesFeaturedArtists = {
    path: '/wedding-planning/suites/shop?featuredArtists=featuredArtist',
    title: 'Our featured artists',
    id: TertiaryNavIdentifier.COLLECTIONS_PAPER,
    parent: PrimaryNavIdentifier.PAPER,
  };

  const items: SecondaryNavItem[] = [];

  const matchingCollectionsChildren = [matchingSuites, matchingSuitesFeaturedArtists, disney];

  const matchingCollectionsParent = {
    ...matchingSuites,
    title: 'Collections',
    children: matchingCollectionsChildren,
    showCaret: true,
  };

  const saveTheDatesParent = {
    ...saveTheDate,
    children: [saveTheDate, changeTheDate],
    showCaret: true,
  };

  const invitationsParent = {
    ...invitations,
    children: [
      { ...invitations, title: 'Wedding invitations' },
      { ...weddingShower },
      { ...enclosureCards },
    ],
    showCaret: true,
  };

  const dayOfParent = {
    path: '/wedding-planning/day-of',
    title: 'Day-of',
    id: TertiaryNavIdentifier.DAY_OF,
    parent: PrimaryNavIdentifier.PAPER,
    children: [placeCards, menus, programs],
    showCaret: true,
  };

  items.push(
    matchingCollectionsParent,
    saveTheDatesParent,
    invitationsParent,
    dayOfParent,
    {
      ...thankYouCards,
    },
    digitalSaveTheDate,
    albums
  );

  return items;
};

export const getGuestListTertiaryItems = (hideTertiaryNav?: boolean) => {
  if (hideTertiaryNav) {
    return [];
  }

  const manage = {
    path: '/wedding/manage/guests/all',
    title: 'Manage guest list',
    id: TertiaryNavIdentifier.MANAGE_GUEST_LIST,
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };
  const invite = {
    path: '/wedding/manage/guests/build',
    title: 'Invite guests to events',
    id: TertiaryNavIdentifier.INVITE_GUESTS,
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };
  const address = {
    path: '/wedding/manage/guests/envelopes',
    title: 'Address envelopes',
    id: TertiaryNavIdentifier.ADDRESS_ENVELOPES,
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };
  const track = {
    path: '/wedding/manage/guests/rsvps/overview',
    title: 'Track RSVPs',
    id: TertiaryNavIdentifier.TRACK_RSVPS,
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };
  return [manage, invite, address, track];
};
